import apiClient from './api';

const budgetService = {
  getAll: async () => apiClient.get('/budgets'),
  create: async (budgetData) => apiClient.post('/budgets', budgetData),
  update: async (id, budgetData) => apiClient.put(`/budgets/${id}`, budgetData),
  delete: async (id) => apiClient.delete(`/budgets/${id}`),
  getByCategory: async (category) => apiClient.get(`/budgets/category/${category}`),
  getSummary: async () => apiClient.get('/budgets/summary'),
  getRemaining: async () => apiClient.get('/budgets/remaining'),
  // 29 ago 2026 (pedido de Augusto: constructor de presupuesto con IA,
  // exclusivo del plan Pro -- ver require_pro_plan_or_above en
  // deps.py): adminOverride replica el mismo "Ignorar y continuar" que
  // ya usan Reports.js/StatementImporter.js para saltarse la cuota de
  // páginas (nunca el chequeo de plan -- eso no tiene bypass).
  aiSuggest: async (adminOverride = false) => apiClient.post('/budgets/ai-suggest', { admin_override: adminOverride }),
};

export default budgetService;
